import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import TabItem from "./TabItem";
import DashboardIcon from "../../../../media/images/icons/dashboard";
import GetLoadIcon from "../../../../media/images/icons/getLoadIcon";
import BoxOutlineIcon from "../../../../media/images/icons/outline-box";
import { useAppDispatch } from "../../../../hooks/useRedux";

import { setOpenOwnerSidebar } from "../../../../redux/features/settingSlice";
import { useLocation } from "react-router-dom";
import UserProfileSvg from "../../../../media/images/icons/user-profile";
import { blueGrey } from "@mui/material/colors";
import MenuIconSVGv2 from "../../../../media/images/icons/menu-iconv2";

export default function BottomTabbar() {
  const theme = useTheme();
  const [, setActiveTab] = useState(0);

  const { pathname } = useLocation();

  const dispatch = useAppDispatch();

  useEffect(() => {});

  const tabItems = [
    {
      icon: (
        <GetLoadIcon
          color={
            pathname === "/owner/add-order"
              ? theme.palette.secondary.main
              : blueGrey[400]
          }
        />
      ),
      title: "سفارش جدید",
      path: "/owner/add-order",
    },
    {
      icon: (
        <DashboardIcon
          color={
            pathname === "/owner/dashboard"
              ? theme.palette.secondary.main
              : blueGrey[400]
          }
        />
      ),
      title: "پیشخوان",
      path: "/owner/dashboard",
    },
    {
      icon: (
        <BoxOutlineIcon
          color={
            pathname === "/owner/manage-orders"
              ? theme.palette.secondary.main
              : blueGrey[400]
          }
        />
      ),
      title: "سفارشات",
      path: "/owner/manage-orders",
    },
    {
      icon: (
        <UserProfileSvg
          color={
            pathname === "/owner/profile"
              ? theme.palette.secondary.main
              : blueGrey[400]
          }
        />
      ),
      title: "پروفایل",
      path: "/owner/profile",
    },
    // {
    //   icon: (
    //     <MedalIcon
    //       color={
    //         pathname === "/owner/karenclub"
    //           ? theme.palette.secondary.main
    //           : theme.palette.info.dark
    //       }
    //     />
    //   ),
    //   title: "کارن کلاب",
    //   path: "/owner/karenclub",
    // },
  ];

  return (
    <Box
      sx={{
        boxShadow: "8px 4px 8px 8px rgba(0,0,0,0.1)",
        position: "fixed",
        bottom: "0px",
        maxWidth: "450px",
        zIndex: 2500,
        bgcolor: "bgColor.white",
        width: "100%",
        // border: "1px solid red",
        display: "flex",
      }}
    >
      <TabItem
        handleClick={() => dispatch(setOpenOwnerSidebar(true))}
        icon={<MenuIconSVGv2 size={24} color={blueGrey[400]} />}
        title={"منو"}
        path=""
      />
      {tabItems.map((item) => (
        <TabItem
          path={item.path}
          handleClick={(index) => setActiveTab(index)}
          icon={item.icon}
          title={item.title}
        />
      ))}
    </Box>
  );
}
